import {
  IPositionResponseChangeLevel,
  IPositionResponseNew,
} from 'services/position/position.interface';
import { IKnowledge } from 'views/pages/KnowledgeArea/knowledge-area.interface';

function convertPosition(position: IPositionResponseNew): IPositionResponseNew {
  const { id, name, orderNo, knowledgeAreas } = position;
  const knowledgeAreasPosition = knowledgeAreas
    .sort((a, b) => a.orderNo - b.orderNo)
    .map(knowledgeArea => ({
      ...knowledgeArea,
      knowledge: {
        ...knowledgeArea.knowledge,
        levels: knowledgeArea.knowledge.levels.sort((a, b) => a.orderNo - b.orderNo),
      },
    }));

  return {
    id,
    name,
    orderNo,
    knowledgeAreas: knowledgeAreasPosition,
  };
}

function convertPositionWithSortedLevels(
  knowledgeArea: IPositionResponseChangeLevel,
): IPositionResponseChangeLevel {
  const { id, knowledge, orderNo, selectedLevel } = knowledgeArea;
  const knowledgeWithSortedLevel = (): IKnowledge => ({
    ...knowledge,
    levels: knowledge.levels.sort((a, b) => a.orderNo - b.orderNo),
  });

  return {
    id,
    knowledge: knowledgeWithSortedLevel(),
    orderNo,
    selectedLevel,
  };
}

export { convertPosition, convertPositionWithSortedLevels };
